import * as React from 'react';
import {ListItem, ListItemProps} from '@material/react-list';

export interface MenuListItemProps<T extends HTMLElement = HTMLElement>
  extends ListItemProps<T> {
  children?: React.ReactNode;
}

class MenuListItem<T extends HTMLElement = HTMLElement> extends React.Component<
  MenuListItemProps<T>,
  {}
> {
  render() {
    const {
      role = 'menuitem',
      children,
      computeBoundingRect,
      ...otherProps
    } = this.props;

    return (
      <ListItem role={role} {...otherProps}>
        {children}
      </ListItem>
    );
  }
}

export default MenuListItem;
